import { css } from "../__compat__/styled-components/main.entry.mjs.mjs";
export const injectOSXFontSmoothing = (enable) => css `
  -moz-osx-font-smoothing: ${enable ? 'grayscale' : 'auto'};
  -webkit-font-smoothing: ${enable ? 'antialiased' : 'auto'};
`;
//# sourceMappingURL=injectOSXFontSmoothing.mjs.mjs.map